import React from 'react';

import { Box, ProgressBar, StatusIndicator } from '@amzn/awsui-components-react-v3';

import { ExecutionDetails } from './ExecutionDetails';

interface ExecutionStatusProps {
  progress?: number;
  totalInProgress?: number;
  totalReceived?: number;
  totalRequested?: number;
  receivedList: any[];
  errorsList: any[];
  executionId?: string;
  pendingList: any[];
  loading: boolean;
}

export const ExecutionProgress = ({
  errorsList = [],
  receivedList = [],
  executionId,
  pendingList = [],
  loading = false,
}: ExecutionStatusProps) => {
  const totalRequested = receivedList.length + errorsList.length + pendingList.length;
  const progress = (100 * receivedList.length) / totalRequested;
  const hundredPercent = progress === 100;

  const getReceiveState = () => {
    if (loading) {
      return <StatusIndicator type="loading">Fetching...</StatusIndicator>;
    }

    if (hundredPercent) {
      return (
        <Box color="text-status-success">
          <StatusIndicator type="success">Received</StatusIndicator>
        </Box>
      );
    }

    const getStatus = () => {
      if (errorsList?.length > 0 && pendingList.length === 0 && totalRequested !== errorsList.length) {
        return <StatusIndicator type="info">Partially Received</StatusIndicator>;
      }

      if (totalRequested === errorsList?.length) {
        return <StatusIndicator type="error">Failed</StatusIndicator>;
      }

      return (
        <StatusIndicator type="loading">{`Receiving ${pendingList.length}/${totalRequested} parts`}</StatusIndicator>
      );
    };

    return <Box>{getStatus()}</Box>;
  };

  return (
    <ProgressBar
      value={progress || 0}
      description={
        <Box>
          {getReceiveState()}
          {!loading && (
            <ExecutionDetails
              errors={errorsList}
              succeded={receivedList}
              pendingList={pendingList}
              executionId={executionId}
            />
          )}
        </Box>
      }
    />
  );
};
